export const usePages = (
  currentPage: number,
  pages: number = 1,
  indeterminate: boolean,
) => {
  const safeCurrentPage = indeterminate
    ? Math.max(currentPage, 1)
    : Math.max(Math.min(currentPage, pages), 1);
  const separator = -1;

  const pagesFromStart = (amountOfPages: number) =>
    Array.from(Array(amountOfPages).keys()).map((page) => page + 1);

  const pagesFromEnd = (amountOfPages: number, lastPage: number) =>
    Array.from(Array(amountOfPages).keys())
      .map((_, index) => lastPage - index)
      .reverse();

  const pagesAroundCurrent = (currentPageNumber: number) => [
    currentPageNumber - 1,
    currentPageNumber,
    currentPageNumber + 1,
  ];

  if (indeterminate) {
    return {
      displayedPages: [currentPage],
      safeCurrentPage,
    };
  }

  if (pages <= 7) {
    return {
      displayedPages: pagesFromStart(pages),
      safeCurrentPage,
    };
  }

  if (safeCurrentPage <= 2 || safeCurrentPage >= pages - 1) {
    return {
      displayedPages: [
        ...pagesFromStart(3),
        separator,
        ...pagesFromEnd(3, pages),
      ],
      safeCurrentPage,
    };
  }

  if (safeCurrentPage === 3) {
    return {
      displayedPages: [
        ...pagesFromStart(4),
        separator,
        ...pagesFromEnd(2, pages),
      ],
      safeCurrentPage,
    };
  }

  if (safeCurrentPage === pages - 2) {
    return {
      displayedPages: [...pagesFromStart(2), -1, ...pagesFromEnd(4, pages)],
      safeCurrentPage,
    };
  }

  return {
    displayedPages: [
      ...pagesFromStart(1),
      separator,
      ...pagesAroundCurrent(currentPage),
      separator,
      ...pagesFromEnd(1, pages),
    ],
    safeCurrentPage,
  };
};
